import { j as e } from "../../../_virtual/jsx-runtime.js";
import { useState as s, useEffect as A } from "react";
import f from "styled-components";
import v from "../Input.js";
import { Form as a, Spin as E, Alert as V, Radio as x, message as m } from "antd";
import _ from "../Button.js";
import L from "./comps/Success.js";
import { useIsMobile as Q } from "../../hook/useIsMobile.js";
import { getInviteInfo as $, setupTotp as z, verifyAndRegister as B } from "../../api/auth/index.js";
import { useSearchParams as P, useNavigate as W } from "react-router-dom";
import { AuthContainer as u, AuthTitle as g, AuthDescription as D, AuthButton as y } from "./styles.js";
function oe(p) {
  const [i] = a.useForm(), [n, r] = s("loading"), [j, d] = s(!1), [b, h] = s(null), [I, w] = s(""), [F, S] = s(""), [k, C] = s(""), l = Q(), [R] = P(), T = W(), c = R.get("token");
  A(() => {
    if (!c) {
      r("invalid"), h("No invite token provided");
      return;
    }
    $(c).then((t) => {
      if (t.code !== 0 || !t.data?.valid) {
        r("invalid"), h(t.data?.expired ? "Invite link expired" : t.data?.used ? "Invite already used" : "Invalid invite");
        return;
      }
      r("email");
    }).catch(() => {
      r("invalid"), h("Failed to validate invite");
    });
  }, [c]);
  const M = async () => {
    if (await i.validateFields(["email", "digits"])) {
      d(!0);
      try {
        const t = i.getFieldValue("digits") || 6, o = await z(c, i.getFieldValue("email"), t);
        if (o.code !== 0 || !o.data) {
          m.error(o.message || "Failed to setup authenticator");
          return;
        }
        w(o.data.qr_code), S(o.data.secret), C(o.data.setup_token), r("qrcode");
      } catch {
        m.error("Failed to setup authenticator");
      } finally {
        d(!1);
      }
    }
  }, q = async () => {
    if (await i.validateFields(["totp_code"])) {
      d(!0);
      try {
        const t = await B({ setup_token: k, totp_code: i.getFieldValue("totp_code") });
        if (t.code !== 0 || !t.data?.success) {
          m.error(t.message || "Invalid code");
          return;
        }
        r("success");
      } catch {
        m.error("Verification failed");
      } finally {
        d(!1);
      }
    }
  };
  return n === "loading" ? /* @__PURE__ */ e.jsxs(u, { children: [
    /* @__PURE__ */ e.jsx(E, { size: "large" }),
    /* @__PURE__ */ e.jsx(G, { children: "Validating..." })
  ] }) : n === "invalid" ? /* @__PURE__ */ e.jsxs(u, { children: [
    /* @__PURE__ */ e.jsx("div", { children: p.logo }),
    /* @__PURE__ */ e.jsx(g, { children: "Invalid Invite" }),
    /* @__PURE__ */ e.jsx(V, { message: b, type: "error", showIcon: !0, style: { marginBottom: 24, maxWidth: 392 } }),
    /* @__PURE__ */ e.jsx(_, { type: "primary", onClick: () => T("/login"), children: "Go to Login" })
  ] }) : n === "success" ? /* @__PURE__ */ e.jsx(L, { title: "Registration Complete", description: "You can now log in with your email and authenticator app." }) : n === "qrcode" ? /* @__PURE__ */ e.jsxs(u, { children: [
    /* @__PURE__ */ e.jsx("div", { children: p.logo }),
    /* @__PURE__ */ e.jsx(g, { children: "Setup Authenticator" }),
    /* @__PURE__ */ e.jsx(D, { children: "Scan this QR code with your authenticator app" }),
    /* @__PURE__ */ e.jsx(N, { children: /* @__PURE__ */ e.jsx("img", { src: `data:image/png;base64,${I}`, alt: "QR" }) }),
    /* @__PURE__ */ e.jsxs(O, { children: [
      "Manual entry: ",
      /* @__PURE__ */ e.jsx("code", { children: F })
    ] }),
    /* @__PURE__ */ e.jsxs(a, { form: i, style: { width: "100%", maxWidth: 392 }, onFinish: q, children: [
      /* @__PURE__ */ e.jsx(a.Item, { name: "totp_code", rules: [{ required: !0, message: "Required" }, { pattern: /^\d{6}(\d{2})?$/, message: "6 or 8 digits" }], children: /* @__PURE__ */ e.jsx(v, { placeholder: "Enter 6 or 8-digit code", label: "Code", maxLength: 8, style: { width: l.isMobile ? "100%" : 392 } }) }),
      /* @__PURE__ */ e.jsx(y, { htmlType: "submit", type: "primary", loading: j, $isMobile: l.isMobile, children: "Complete" })
    ] })
  ] }) : /* @__PURE__ */ e.jsxs(u, { children: [
    /* @__PURE__ */ e.jsx("div", { children: p.logo }),
    /* @__PURE__ */ e.jsx(g, { children: "Create Account" }),
    /* @__PURE__ */ e.jsxs(a, { form: i, style: { width: "100%", maxWidth: 392 }, onFinish: M, initialValues: { digits: 6 }, children: [
      /* @__PURE__ */ e.jsx(a.Item, { name: "email", rules: [{ required: !0, message: "Required" }, { type: "email", message: "Invalid email" }], children: /* @__PURE__ */ e.jsx(v, { placeholder: "Enter email", label: "Email", style: { width: l.isMobile ? "100%" : 392 } }) }),
      /* @__PURE__ */ e.jsx(a.Item, { name: "digits", label: "TOTP Digits", children: /* @__PURE__ */ e.jsxs(x.Group, { children: [
        /* @__PURE__ */ e.jsx(x, { value: 6, children: "6 digits (standard)" }),
        /* @__PURE__ */ e.jsx(x, { value: 8, children: "8 digits (more secure)" })
      ] }) }),
      /* @__PURE__ */ e.jsx(y, { htmlType: "submit", type: "primary", loading: j, $isMobile: l.isMobile, children: "Continue" })
    ] })
  ] });
}
const G = f.div`
  color: var(--color-text-secondary);
  font-size: 14px;
  margin-top: 16px;
`, N = f.div`
  background: white;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  img { width: 200px; height: 200px; }
`, O = f.div`
  color: var(--color-text-secondary);
  font-size: 12px;
  margin-bottom: 24px;
  code { background: rgba(0,0,0,0.05); padding: 2px 6px; border-radius: 4px; font-family: monospace; }
`;
export {
  oe as default
};
